export enum TaskType {
    InboundFlight = "InboundFlight",
    OutboundFlight = "OutboundFlight",
    Terminal = "Terminal",
    RemoteParking = "RemoteParking",
    Other = "Other"
}